import type { TaskDocument } from './schema'
import { authStore } from '@/store/auth'
import { orgStore } from '@/store/org'

export interface OfflineScope {
  userId: number
  orgId: number
}

export function getOfflineScope(): OfflineScope | null {
  const userId = authStore.getState().user?.id
  const orgId = orgStore.getState().org?.id
  if (!userId || !orgId) return null
  return { userId, orgId }
}

export function cursorKey(scope: OfflineScope): string {
  return `granula_sync_cursor:${scope.userId}:${scope.orgId}`
}

export function taskMatchesScope(
  task: Pick<TaskDocument, 'org_id' | 'user_id' | 'assigned_to' | 'created_by'>,
  scope: OfflineScope,
  mode?: 'mine' | 'created',
): boolean {
  if (task.org_id !== scope.orgId || task.user_id !== scope.userId) return false
  if (mode === 'mine') return task.assigned_to === scope.userId
  if (mode === 'created') return task.created_by === scope.userId
  return true
}
